import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/crypto_deposit';
import {setPreset} from '../../../../../reducers/wallet/actions';
import ModalsLib from '../../../../../lib/modals';
import BlueButton from '../../../../components/blue-button';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from 'react-toastify';

import {useEffect} from 'react';
import Triggers from '../../../../../lib/triggers';

import QRCode from './qrCode';

export default () => {
    const {props} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        Triggers.modal_open({
            modal: "wallet",
            tab: "deposit_crypto",
            method: "crypto",
            token: props.name
        });
    }, [])


    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">{props.name}</div>
                    <div className="descriptions">Make crypto deposits to your personal wallet</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                {/* <div className="crypto-deposit">
                    <div className="wallet-details">
                        <div className="qrcode">
                            <QRCode address={props.address} />
                        </div>
                        <div className="details">
                            <div className="detail">
                                <div className="detail-value">
                                    <div className="title">Your <b>eternal</b> wallet</div>
                                    <div className="value">0xE60CE<span>*********</span>62DA3D</div>
                                </div>
                                <div className="detail-copy">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.6666 8.59992V11.3999C10.6666 13.7333 9.73325 14.6666 7.39992 14.6666H4.59992C2.26659 14.6666 1.33325 13.7333 1.33325 11.3999V8.59992C1.33325 6.26658 2.26659 5.33325 4.59992 5.33325H7.39992C9.73325 5.33325 10.6666 6.26658 10.6666 8.59992Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14.6666 4.59992V7.39992C14.6666 9.73325 13.7333 10.6666 11.3999 10.6666H10.6666V8.59992C10.6666 6.26658 9.73325 5.33325 7.39992 5.33325H5.33325V4.59992C5.33325 2.26659 6.26658 1.33325 8.59992 1.33325H11.3999C13.7333 1.33325 14.6666 2.26659 14.6666 4.59992Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                            <div className="detail">
                                <div className="detail-value">
                                    <div className="title">Minimal deposit amount</div>
                                    <div className="value">{props.minimal} {props.name}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <QRCode address={props.address} />

                <div className="modal-text">Only <b>{props.name}</b> in the <b>{props.network}</b> network can be transferred to the deposit address. <u>Do not transfer other coins!</u></div>
            
                <div className="crypto-details">
                    <div className="detail">
                        <div className="label">
                            Your <b>eternal</b> wallet
                        </div>
                        <div className="value">{props.address}</div>
                    </div>
                    <hr />
                    <div className="detail">
                        <div className="label">
                            Minimal deposit amount
                        </div>
                        <div className="value">{props.minimal} {props.token.split('_')[0]}</div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <CopyToClipboard text={props.address} onCopy={e => {
                    toast.dismiss();
                    toast.info(`The ${props.name} wallet on the ${props.network} network has been copied to the clipboard!`);
                }}>
                    <BlueButton>
                        Copy address
                    </BlueButton>
                </CopyToClipboard>
                <div className="button back" onClick={e => dispatch(setPreset({
                    mode: 'tabs',
                    tab: 'deposit-crypto'
                }))}>
                    Back
                </div>
            </div>
        </>
    )
}